import apiClient from './apiClient'
import qs from 'qs'

const CSRF_TOKEN = document.head.querySelector('meta[name="csrf-token"]').content

const request = apiClient({
  headers: {
    common: {
      'x-csrf-token': CSRF_TOKEN,
      'X-Requested-With': 'XMLHttpRequest'
    }
  },
  paramsSerializer: params => qs.stringify(params)
})

export default request
